import { ChangeCircle } from '@mui/icons-material'
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos'
import React from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function TagliaBox({currentPlan}) {
    const navigate = useNavigate()
    const taglia = useSelector((user) => user.user.importo_taglia)

    return (
        <>
           {currentPlan === 2 ? (
               <div className="tesBox">
                    <div className="soglia">
                        <p className="label">La tua taglia</p>
                        <span className="number">{taglia && taglia} <span className="currency">€</span></span>
                    </div>
                    <div className="discoverPlans" onClick={() => navigate('/enrica/fai-da-te/soglia-taglia')}>
                        <ChangeCircle className='changeIcon'/>
                        <p>Modifica taglia</p>
                        <ArrowForwardIos className='arrow'/>
                    </div>
                </div>
           ) : null} 
        </>
    )
}

export default TagliaBox